import { Vue } from 'ui.vue';
import { Loc, Currency } from 'main.core';
// import { userStore } from 'germes.multibasket';
// import { } from 'germes.contragent';
import BonusProgram from '../entity/BonusProgram'
userStore.registerModule('bonus', {
    namespaced: true,
    state: {
        initHandler: false,
        saleType: 'NO_BONUS_PROGRAM',
        spentBonusPrice: 0,
        spentBonusValue: 0,
        defbonusPrograms: [new BonusProgram(
            {
                ID: 0,
                SORT: 10,
                XML_ID: '',
                NAME: Loc.getMessage('NO_BONUS_PROGRAM_NAME'),
                CODE: 'NO_BONUS_PROGRAM',
                DESCRIPTION: Loc.getMessage('NO_BONUS_PROGRAM_DESCRIPTION'),
                HELP: Loc.getMessage('NO_BONUS_PROGRAM_HELP'),
                IMAGE: '',
                TYPE: 'NONE',
            })
        ],
        bonusPrograms: [new BonusProgram({
            ID: 1,
            SORT: 20,
            XML_ID: '',
            NAME: Loc.getMessage('ORDER_PROP_PAYED_FROM_ACCOUNT_NAME'),
            CODE: 'ORDER_PROP_PAYED_FROM_ACCOUNT',
            DESCRIPTION: Loc.getMessage('ORDER_PROP_PAYED_FROM_ACCOUNT_DESCRIPTION'),
            HELP: Loc.getMessage('ORDER_PROP_PAYED_FROM_ACCOUNT_HELP'),
            IMAGE: '',
            TYPE: 'GENERAL',
        }),
        ],
        ProductSettingsModule: []
    },
    mutations: {
        addBonusProgram(state, bonusProgramObj) {
            if (bonusProgramObj.NAME
                && bonusProgramObj.ID
                && state.bonusPrograms.filter(function (bonusProgram) {
                    return bonusProgram.XML_ID == bonusProgramObj.XML_ID;
                }).length == 0
            ) {
                state.bonusPrograms.push(new BonusProgram(bonusProgramObj));
            }
        },
        setSaleType(state, saleType) {
            let event = { data: { state: state, saleType: saleType }, result: true };
            BX.onCustomEvent('OnBeforeBasketChangeSaleType', event);
            if (event.result == true) {
                if (!event.data.saleType) state.saleType = 'NO_BONUS_PROGRAM';
                    else state.saleType = event.data.saleType;
                this.dispatch('bonus/reCalcSaleProgram');
                BX.onCustomEvent("OnAfterBasketChangeSaleType", event);
                // BX.onCustomEvent("OnBasketChange");
            }
        },
        setContragentBonus(state, { contragent_id, bonusObj, bonus_summ }) {
            if (typeof bonusObj == 'object' && contragent_id != undefined) {
                let contragentObj = state.data.user.CONTRAGENTS[contragent_id];
                contragentObj.BONUS = bonusObj;
                contragentObj.BONUS_SUMM = bonus_summ;
                if (contragent_id == state.data.user.ACTIVE_CONTRAGENT.ID) {
                    state.data.user.ACTIVE_CONTRAGENT.BONUS = bonusObj;
                    state.data.user.ACTIVE_CONTRAGENT.BONUS_SUMM = bonus_summ;
                }
            }
        },
        setSpentBonusPrice(state, value) {
            state.spentBonusPrice = value;
        },
        setSpentBonusValue(state, value) {
            state.spentBonusValue = value;
        },
    },
    actions: {
        initEventHandler: function (state) {
            if (state.state.initHandler === false) {
                BX.addCustomEvent('OnAfterContragentSetAction', BX.delegate((event) => {
                    if (event.data.action && event.data.action.TYPE == 'ORDER_BUY_PRODUCT_BONUS') {
                        event.data.action.CODE = event.data.action.TYPE;
                        this.commit('bonus/addBonusProgram', event.data.action);
                    }
                }, this));
                BX.addCustomEvent('OnBeforeProductBonusBuyOn', BX.delegate((event) => {
                    if (this.getters['bonus/getItemsInCartBuyBonusPrice'] > this.getters['bonus/getMaxBonusCartPrice']) {
                        event.data.return = false;
                    }
                }, this));
                BX.addCustomEvent('OnAfterProductBonusBuyOn', BX.delegate((event) => {
                    this.dispatch('bonus/reCalcSaleProgram');
                }, this));
                BX.addCustomEvent('OnAfterProductBonusBuyOff', BX.delegate((event) => {
                    this.dispatch('bonus/reCalcSaleProgram');
                }, this));
                BX.addCustomEvent('OnBeforeBasketAddProduct', BX.delegate((event) => {
                    this.dispatch('bonus/checkItemsInCartBuyBonus').then(response => {
                        console.log(response);
                    }, error => {
                        console.error(event);
                    });
                }, this));
                BX.addCustomEvent('OnAfterBasketDeleteProduct', BX.delegate((event) => {
                    this.dispatch('bonus/reCalcSaleProgram');
                }, this));
                BX.addCustomEvent('OnAfterBasketAddProduct', BX.delegate((event) => {
                    this.dispatch('bonus/reCalcSaleProgram');
                }, this));
                BX.addCustomEvent('OnAfterBasketUpdateProduct', BX.delegate((event) => {
                    this.dispatch('bonus/reCalcSaleProgram');
                }, this));
                BX.addCustomEvent('OnAfterBasketSet', BX.delegate((event) => {
                    this.commit('bonus/setSaleType', null);
                }, this));
                BX.addCustomEvent('OnBeforeBasketElementUpdate', BX.delegate((event) => {
                    let product = event.data;
                    if (this.getters['bonus/getSaleType'] == 'ORDER_BUY_PRODUCT_BONUS') {
                        if (product?.PROPS?.BONUS_EXCHANGE?.VALUE == 'Y') {
                            product.PRICE = 0;
                            product.DISCOUNT_PRICE = product.BASE_PRICE;
                        } else {
                            product.PRICE = product.BASE_PRICE;
                            product.DISCOUNT_PRICE = null;
                        }
                    } else {
                        product.PRICE = product.BASE_PRICE;
                        product.DISCOUNT_PRICE = null;
                    }
                }, this));
                BX.addCustomEvent('OnAfterBasketElementUpdate', BX.delegate((event) => {
                }, this));
                BX.addCustomEvent('OnAfterBasketChangeSaleType', BX.delegate((event) => {
                    if (this.getters['bonus/getSaleType'] != 'ORDER_BUY_PRODUCT_BONUS') {
                        let itemList = this.getters['basket/getItems'];
                        for (const id in itemList) {
                            if (Object.hasOwnProperty.call(itemList, id)) {
                                let product = itemList[id];
                                product.PRICE = product.BASE_PRICE;
                                product.DISCOUNT_PRICE = null;
                                this.commit('basket/updateBasketItem', product);
                            }
                        }
                    }
                }, this));
                BX.addCustomEvent("OnBeforeContragentChange", BX.delegate((event) => {
                    if (this.getters['bonus/getItemsInCartBuyBonusPrice'] > 0 && this.getters['bonus/getSaleType'] != 'NO_BONUS_PROGRAM') {
                        if (!confirm(Loc.getMessage('CONTRAGENT_CHANGE_CONFIRM').replace('#CONTRAGENT_NAME#', this.getters['basket/getContragent']?.NAME))) {
                            event.data.return = false;
                        }
                    }
                }, this));
                state.state.initHandler = true;
                BX.ready(BX.proxy(function () {
                    BX.onCustomEvent("OnAfterBonusStoreInit");
                }, this));
            }
        },
        checkItemsInCartBuyBonus: function (state) {
            return new Promise((resolve, reject) => {
                let maxBonusCartValue = state.getters.getMaxBonusCart?.PRICE;
                let ItemsInCartBuyBonusValue = state.getters.getItemsInCartBuyBonusPrice;
                if (parseFloat(maxBonusCartValue) < parseFloat(ItemsInCartBuyBonusValue)) {
                    let error = Loc.getMessage("PRODUCT_BUY_BONUS_ERROR")
                        .replace("#MAX_BONUS_PRICE#", maxBonusCartValue)
                        .replace("#CART_ITEMS_BONUS_PRICE#", ItemsInCartBuyBonusValue);
                    reject(error);
                } else {
                    resolve(true);
                }
            })
        },
        reCalcSaleProgram: function (store) {
            switch (store.state.saleType) {
                case 'ORDER_PROP_PAYED_FROM_ACCOUNT':
                    store.commit('setSpentBonusPrice', store.getters['getMaxBonusCartPrice']);
                    store.commit('setSpentBonusValue', store.getters['getMaxBonusCartValue']);
                    break;
                case 'ORDER_BUY_PRODUCT_BONUS':
                    store.commit('setSpentBonusPrice', store.getters['getItemsInCartBuyBonusPrice']);
                    store.commit('setSpentBonusValue', store.getters['getItemsInCartBuyBonusValue']);
                    break;
                default:
                    store.commit('setSpentBonusPrice', 0);
                    store.commit('setSpentBonusValue', 0);
                    break;
            }
        }
    },
    getters: {
        localize: (state) => (CODE) => {
            return BX.Vue.getFilteredPhrases('')[CODE];
        },
        getBonusPrograms: (state, getters, rootState, rootGetters) => {
            return state.defbonusPrograms.concat(state.bonusPrograms)
                .sort((a, b) => a.SORT > b.SORT ? 1 : -1)
                .filter((bonusProgram) => {
                    return bonusProgram.isPossibileToUse({
                        contragent: rootGetters['basket/getContragent'],
                        user: rootGetters['getUser'],
                    })
                });
        },
        getSaleType: (state) => {
            return state.saleType;
        },
        getSaleTypeProgram: (state, getters, rootState, rootGetters) => (saleType) => {
            saleType ??= state.saleType;
            let bonusPrograms = getters.getBonusPrograms;
            for (const i in bonusPrograms) {
                if (Object.hasOwnProperty.call(bonusPrograms, i)
                    && bonusPrograms[i].CODE == state.saleType
                ) {
                    return bonusPrograms[i];
                }
            }
            return null;
        },
        getSpentBonusPrice: (state) => {
            return state.spentBonusPrice;
        },
        getSpentBonusValue: (state) => {
            return state.spentBonusValue;
        },
        getBonusList: (state, getters, rootState, rootGetters) => {
            return rootGetters['basket/getContragent']?.BONUS;
        },
        getBonusTotalSum: (state, getters, rootState, rootGetters) => {
            return parseFloat(rootGetters['basket/getContragent']?.BONUS_SUMM) || 0;
        },
        getBonusTotalSumCurrency: (state, getters, rootState, rootGetters) => {
            return BX?.Currency?.currencyFormat(getters.getBonusTotalSum, getters.getCartCurrency, false).replace(/&nbsp;/g, ' ');
        },
        getBonusTotalSumInCurs: (state, getters, rootState, rootGetters) => {
            let sum = 0;
            if (rootGetters['basket/getContragent']?.BONUS?.length && rootGetters['basket/getContragent']?.BONUS_SUMM) {
                sum = parseFloat(rootGetters['basket/getContragent']?.BONUS_SUMM) * parseFloat(rootGetters['basket/getContragent']?.BONUS[0]?.CURS);
            }
            return sum;
        },
        getBonusTotalSumInCurrency: (state, getters, rootState, rootGetters) => {
            let sum = 0;
            if (getters.getBonusTotalSumInCurs && getters.getCartCurrency) {
                sum = BX?.Currency?.currencyFormat(getters.getBonusTotalSumInCurs, getters.getCartCurrency, true).replace(/&nbsp;/g, ' ');
            }
            return sum;
        },
        getCartCurrency: (state, getters, rootState, rootGetters) => {
            return rootGetters['basket/getCurrency'];
        },
        getUserBonusPossibilityForProduct: (state, getters, rootState, rootGetters) => (SaleType, product) => {
            return (product?.QUANTITY > 0
                && getters.getBonusTotalSum > 0
                && !!getters.getSaleTypeProgram(SaleType ?? getters.getSaleType)?.isPossibileToUse({
                    product: product,
                    contragent: rootGetters['basket/getContragent'],
                    user: rootGetters['getUser'],
                })
            );
        },
        getUserBonusPossibilityForProductBuy: (state, getters, rootState, rootGetters) => (SaleType, product) => {
            if (getters.getUserBonusPossibilityForProduct(SaleType, product)) {
                let itemsInCartBuyBonusSum = getters.getItemsInCartBuyBonusSum;
                let bonusTotalSumInCurs = getters.getBonusTotalSumInCurs;
                return (bonusTotalSumInCurs >= itemsInCartBuyBonusSum + (product.QUANTITY * product.BASE_PRICE));
            }
            return false;
        },
        getItemsInCartBuyBonus: (state, getters, rootState, rootGetters) => {
            let itemsInCartBuyBonus = {};
            if (rootState.basket != undefined) {
                let cartItems = rootGetters['basket/getItems'];
                for (const id in cartItems) {
                    if (Object.hasOwnProperty.call(cartItems, id)
                        && cartItems[id]?.PROPS?.BONUS_EXCHANGE?.VALUE == 'Y'
                    ) {
                        itemsInCartBuyBonus[id] = cartItems[id];
                    }
                }
            }
            return itemsInCartBuyBonus;
        },
        getItemsInCartBuyBonusSum: (state, getters, rootState, rootGetters) => {
            let cartBonusSum = 0,
                itemsInCartBuyBonus = getters.getItemsInCartBuyBonus;
            if (itemsInCartBuyBonus) {
                for (const i in getters.getItemsInCartBuyBonus) {
                    if (Object.hasOwnProperty.call(getters.getItemsInCartBuyBonus, i)) {
                        const cartElement = getters.getItemsInCartBuyBonus[i];
                        cartBonusSum += parseFloat(cartElement.BASE_PRICE) * parseFloat(cartElement.QUANTITY);
                    }
                }
            }
            return parseFloat(cartBonusSum);
        },
        getItemsInCartBuyBonusPrice: (state, getters, rootState, rootGetters) => {
            return getters.getItemsInCartBuyBonusSum;
        },
        getItemsInCartBuyBonusValue: (state, getters, rootState, rootGetters) => {
            return getters.getItemsInCartBuyBonusSum;
        },
        getItemsInCartBuyBonusSumCurrency: (state, getters, rootState, rootGetters) => {
            let currency_name = rootGetters['basket/getCurrency'];
            return getters.getItemsInCartBuyBonusSum && currency_name ? BX?.Currency?.currencyFormat(getters.getItemsInCartBuyBonusSum, currency_name, true).replace(/&nbsp;/g, ' ') : "";
        },
        getItemsInCartBuyBonusCount: (state, getters, rootState, rootGetters) => {
            return Object.keys(getters.getItemsInCartBuyBonus)?.length;
        },
        getMaxBonusCart: (state, getters, rootState, rootGetters) => {
            let totalPrice = rootGetters['basket/getBasketPriceAvailable'];
            let bonusList = getters.getBonusList;
            let bonusListUsed = [];
            let spentBonusPrice = 0;
            let spentBonusValue = 0;
            if (typeof bonusList == 'object' && Object.keys(bonusList).length && totalPrice > 0) {
                let totalPrice_copy = totalPrice;
                let $maxSale = totalPrice_copy * 0.2;
                let $totalSale = 0;
                let $totalValue = 0;
                for (const i in bonusList) {
                    if (Object.hasOwnProperty.call(bonusList, i)) {
                        let $bonus = bonusList[i];
                        // $bonus['MAX_VALUE'] = $bonus['MAX_VALUE']?:1;
                        // $maxBonusPrice = totalPrice * $bonus['MAX_VALUE'] / 100;

                        // Определили стоимость бонуса
                        $bonus.VALUE_CONVERTED = $bonus.VALUE * $bonus.CURS;
                        $bonus.PRICE_SPENT = $bonus.VALUE * $bonus.CURS;
                        if ($bonus.PRICE_SPENT > $maxSale) {
                            $bonus.PRICE_SPENT = $maxSale;
                        } else if ($bonus.PRICE_SPENT <= $maxSale) {
                            //
                        }

                        // Определили бонусы
                        $bonus.SPENT_IN_PERCENT = $bonus.PRICE_SPENT * 100 / $bonus.VALUE_CONVERTED; // процент потраченного
                        $bonus.LEFT_IN_PERCENT = 100 - $bonus.SPENT_IN_PERCENT;
                        $bonus.LEFT_VALUE = ($bonus.VALUE_CONVERTED - $bonus.PRICE_SPENT) / $bonus.CURS;
                        $bonus.SPENT_VALUE = $bonus.LEFT_VALUE ? $bonus.VALUE - $bonus.LEFT_VALUE : $bonus.VALUE;

                        bonusListUsed.push($bonus);
                        totalPrice_copy -= parseFloat($bonus.PRICE_SPENT);
                        if (totalPrice_copy <= 0) {
                            break;
                        }
                        $maxSale -= parseFloat($bonus.PRICE_SPENT);
                        $totalValue += parseFloat($bonus.SPENT_VALUE);
                        $totalSale += parseFloat($bonus.PRICE_SPENT);
                        if (!$maxSale) {
                            break;
                        }
                    }
                }
                spentBonusPrice = parseFloat($totalSale).toFixed(2);
                spentBonusValue = parseInt($totalValue);
            }
            return {
                PRICE: spentBonusPrice,
                VALUE: spentBonusValue
            }
        },
        getMaxBonusCartPrice: (state, getters, rootState, rootGetters) => {
            return parseFloat(getters.getMaxBonusCart?.PRICE || 0);
        },
        getMaxBonusCartPriceCurrency: (state, getters, rootState, rootGetters) => {
            return (BX?.Currency?.currencyFormat(getters.getMaxBonusCartPrice, rootGetters['basket/getCurrency'], false))
                ?.replace(/&nbsp;/gi, ' ');
        },
        getMaxBonusCartValue: (state, getters, rootState, rootGetters) => {
            return parseFloat(getters.getMaxBonusCart?.VALUE || 0);
        },
        getMaxBonusCartValueCurrency: (state, getters, rootState, rootGetters) => {
            return (BX?.Currency?.currencyFormat(getters.getMaxBonusCartValue, rootGetters['basket/getCurrency'], false))
                ?.replace(/&nbsp;/gi, ' ');
        },
    }
});
userStore.dispatch('bonus/initEventHandler');
